import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import useAuthStore from '../store/useAuthStore';

export default function GoogleAuthSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);
  const [message, setMessage] = useState('Completing Google sign-in...');

  useEffect(() => {
    async function finish() {
      const token = searchParams.get('token');
      if (!token) {
        setMessage('Google sign-in did not return a session token.');
        return;
      }
      localStorage.setItem('token', token);
      try {
        const { data } = await api.get('/auth/me');
        login(token, data.user);
        if (data.user?.role === 'platform_admin') {
          navigate('/platform-admin/business-control', { replace: true });
          return;
        }
        if (data.user?.subscriptionAccess && !data.user.subscriptionAccess.allowed) {
          navigate('/subscription/renew', { replace: true });
          return;
        }
        navigate(data.user?.setupCompleted ? '/dashboard' : '/setup', { replace: true });
      } catch (error) {
        localStorage.removeItem('token');
        setMessage(error?.response?.data?.error || 'Google sign-in could not be completed.');
      }
    }
    finish();
  }, [login, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="rounded-3xl bg-white p-8 shadow-xl text-center">
        <h1 className="text-2xl font-bold text-slate-900">Google Sign-In</h1>
        <p className="mt-3 text-sm text-slate-600">{message}</p>
      </div>
    </div>
  );
}
